import { render, staticRenderFns } from "./InsuranceRefundHome.vue?vue&type=template&id=2471d69c&scoped=true&"
import script from "./InsuranceRefundHome.vue?vue&type=script&lang=js&"
export * from "./InsuranceRefundHome.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceRefundHome.vue?vue&type=style&index=0&id=2471d69c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2471d69c",
  null
  
)

export default component.exports